import { useMutation, useQueryClient } from "react-query";

import { ThemeCreate, ThemeUpdate } from "../../models/theme/Theme";
import useApiHelper from "../../services/useApiHelper";
import { themeQueryKeys } from "./queryKeys";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";

export function useThemeMutations() {
  const queryClient = useQueryClient();
  const { put, post } = useApiHelper();
  const { saveHandlers } = useDefaultCRUDHandlers("Theme");

  const create = useMutation((theme: ThemeCreate) => post(`/theme`, theme), {
    ...saveHandlers,
    onSuccess: () => {
      queryClient.invalidateQueries(themeQueryKeys._base());
      saveHandlers.onSuccess?.();
    },
  });

  const update = useMutation(
    (theme: ThemeUpdate) => put(`/theme/${theme.id}`, theme),
    {
      ...saveHandlers,
      onSuccess: () => {
        queryClient.invalidateQueries(themeQueryKeys._base());
        saveHandlers.onSuccess?.();
      },
    }
  );

  return {
    create,
    update,
  };
}
